<template>
    <div class="serial-boost">
        <dynamic-display :load-data-api="getLoadSerialBoostApi()" @loadEnd="onLoadEnd" ref="dynamicDisplay" class="dynamic-display">
            <template v-slot:showResultsContainer v-if="documentList">
                <div class="description">{{documentList.length}} Documents</div>
                <div class="document-list">
                    <document-list-item class="document-item" v-for="(item,index) in documentList" :key="index" :item="item"
                                        @click.native="onClickDocumentItem($event, item['global_document_id'])">
                    </document-list-item>
                </div>
            </template>
        </dynamic-display>
    </div>
</template>

<script>
    import {getSerialBoostList} from "@/apis";
    import {documentStatusIdToLabel} from "@/config";
    import {checkCrossPlatformEventCtrlKey} from "@/utils";
    import DocumentListItem from "@/components/DocumentListItem";
    import DynamicDisplay from "@/components/DynamicDisplay";

    export default {
        name: "SerialBoost",
        components: {DynamicDisplay, DocumentListItem},
        data() {
            return {
                documentList: null,
                documentStatusIdToLabel,
            }
        },
        props: [
            'globalDocumentId',
            'projectId',
        ],
        methods: {
            onLoadEnd(showingResults, results) {
                if (showingResults) {
                    this.documentList = results;
                }
                this.$emit('loadEnd', showingResults, results);
            },
            getLoadSerialBoostApi() {
                return getSerialBoostList.bind(null, this.globalDocumentId);
            },
            onClickDocumentItem(event, global_document_id) {
                this.eventHub.$emit('openDocument', {
                    globalDocumentId: global_document_id,
                    silent: checkCrossPlatformEventCtrlKey(event),
                    projectId: this.projectId,
                });
            },
            loadData() {
                this.$refs.dynamicDisplay.loadData();
            }
        },
    }
</script>

<style scoped lang="scss">
    .description {
        color: gray;
        text-align: center;
        padding: 0.25rem 0.5rem;
        min-width: 132px;
    }

    .document-item {
        &:not(:last-child) {
            border-bottom: 1px solid rgba(black, 0.08);
        }

        cursor: pointer;

        &:hover {
            background-color: rgba(black, 0.08);
        }
    }
</style>
